<template>
  <div class="h-screen w-screen bg-neutral-white flex items-center justify-center">
    <div class="text-center">
      <div class="text-xl">Ooops you caught us while we were under construction!</div>
      <PulseButton size="large" class="mx-auto mt-8" @click="$router.back"> Go back </PulseButton>
    </div>
  </div>
</template>
